import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// import { getAuth} from "firebase/auth";
// import configuration from "./config";
const firebaseConfig = {
  apiKey: "AIzaSyCZAl1yelA-cFx0FRkGOKanbfxwmHUblL0",
  authDomain: "udrive-ethiopia-1f873.firebaseapp.com",
  databaseURL:
    "https://udrive-ethiopia-1f873-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "udrive-ethiopia-1f873",
  storageBucket: "udrive-ethiopia-1f873.firebasestorage.app",
  messagingSenderId: "900106447108",
  appId: "1:900106447108:web:25c003c66dd12d7d420851",
  measurementId: "G-J0YVLFGT18",
};
// const firebaseConfig = {
//     apiKey: "AIzaSyB-n-cV916Jswrm4DLFz-oIsKxsbgt1sW8",
//     authDomain: "peindia-af604.firebaseapp.com",
//     databaseURL: "https://peindia-af604-default-rtdb.firebaseio.com",
//     projectId: "peindia-af604",
//     storageBucket: "peindia-af604.appspot.com",
//     messagingSenderId: "1007818613150",
//     appId: "1:1007818613150:web:b89ba82d1a2f7b4873768f",
//     measurementId: "G-32MQWBZYLH"
// };
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
// const auth = getAuth(app);
export default database;